import { render } from "./OwnTeamPage.vue?vue&type=template&id=58834c48&scoped=true"
import script from "./OwnTeamPage.vue?vue&type=script&lang=js"
export * from "./OwnTeamPage.vue?vue&type=script&lang=js"

import "./OwnTeamPage.vue?vue&type=style&index=0&id=58834c48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58834c48"]])

export default __exports__